import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { formatStringToNumber } from 'utils/formatters';
import { InputField, SelectField } from 'components/form';
import { EquipmentFormValue } from '../../../../types';
import { FieldsContainer } from '../../../components/FieldsContainer';
import { equipmentConditions, equipmentYears, makeOptions } from '../../../../constants';

export const CommonInfo = () => {
  const { control } = useFormContext<EquipmentFormValue>();

  return (
    <FieldsContainer columns={5}>
      <Stack direction="row" gap="0.5rem">
        <InputField
          label="Quantity"
          control={control}
          name="commonInfo.quantity"
          formatter={formatStringToNumber}
          inputProps={{ type: 'number', variant: 'outlined' }}
        />

        <SelectField
          label="Year"
          control={control}
          variant="outlined"
          name="commonInfo.year"
          options={equipmentYears}
        />
      </Stack>

      <SelectField
        label="Condition"
        control={control}
        variant="outlined"
        name="commonInfo.condition"
        options={equipmentConditions}
      />

      <SelectField label="Make" control={control} variant="outlined" name="commonInfo.make" options={makeOptions} />

      <InputField label="Model" name="commonInfo.model" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField label="Serial/VIN#" name="commonInfo.vin" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField label="Stock ID" name="commonInfo.stockId" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField
        label="Mileage"
        control={control}
        name="commonInfo.mileage"
        formatter={formatStringToNumber}
        inputProps={{ type: 'number', variant: 'outlined' }}
      />

      <InputField
        label="Class"
        control={control}
        name="commonInfo.class"
        formatter={formatStringToNumber}
        inputProps={{ variant: 'outlined' }}
      />

      <InputField
        control={control}
        label="Description"
        name="commonInfo.description"
        inputProps={{ variant: 'outlined', sx: { gridColumn: '4 / 6' } }}
      />
    </FieldsContainer>
  );
};
